import * as React from 'react';
import './SelfShipping.scss';
import RadioButton from 'src/components/common/RadioButton';
import Dropdown from 'src/components/common/Dropdown';
import Button from 'src/components/common/Button';
import cartService from 'src/services/cart/CartService';
import locationServiceInstance from 'src/services/location/LocationService';

export const SELF_SHIPPING = 'selfShipping';
export const PURCHASE_PREPAID_SHIPPING = 'purchasePrepaidShipping';
import returnsServiceInstance from 'src/services/returns/returnsService';

interface IShippingOptionsProps {
  distributionSelectedOption: string;
  handleDistributionChangeOption: (e: any) => void;
  rmaSelected: string;
  storeList:any[];
  isLoading: boolean;
  handleSelfShippingWarehouse: (value:string)=> void;
  t?: any;
}

const SelfShipping: React.FC<IShippingOptionsProps> = props => {
  const {
    rmaSelected,
    distributionSelectedOption,
    handleDistributionChangeOption,
    storeList,
    isLoading,
    handleSelfShippingWarehouse,
    t
  } = props;

  const [zipCode,setZipCode]=React.useState('');
  const [selfStoreList,setSelfStoreList]=React.useState([]);
  const [SelfShippingLoader,setSelfShippingLoader]=React.useState(false);

  const getAddresses = async (
    postalCode: string,
    value?: boolean
  ) => {
    const newStoreList: any[] = [];
    newStoreList.push({
      code: '0',
      name: 'Select',
      addr: 'warehouse'
    });
      await returnsServiceInstance
      .getUpsSyncedLocations(postalCode)
      .then(response => {
        response.upsEnabledWarehousesList.forEach((address: any) => {
          newStoreList.push({
            code: address.warehouseCode,
            name: address.city,
            addr: address.address
          });
        });
      }).catch(error => {
        console.log(error);
      });  
    return newStoreList;
  };

  React.useEffect(()=>{
    let deliveryAddresses: any[] = [];
    cartService.getCartShippingAddress().then(async r => {
      setZipCode(r.deliveryLocation.postalCode);
      deliveryAddresses = await getAddresses(
        r.deliveryLocation.postalCode,
        true
      );
      setSelfStoreList(deliveryAddresses);
    });
  },[]);

  const getSelectedOption = () => {
    const options = {
      selfShipping: false,
      purchasePrepaidShipping: false
    };

    options[distributionSelectedOption] = true;
    return options;
  };
  const selection = getSelectedOption();

  const getAddressByZipCode=()=>{
    setSelfShippingLoader(true);
    let deliveryAddresses: any[] = [];
    cartService.getCartShippingAddress().then(async r => {
      deliveryAddresses = await getAddresses(
        zipCode,
        false
      );
      setSelfStoreList(deliveryAddresses);
      setSelfShippingLoader(false);
    });

  }

  const handleZipCode = (e: any) => {
    setZipCode(e.target.value.toUpperCase());
  };

  
  return (

        <div className="self-shipping-mobile-container">
          <div>{t('myReturns.searchStore')}</div>
          <div>
            
          <input
            type="text"
            value={zipCode}
            onChange={handleZipCode}
            disabled={null}
            className="rp-returns-options-in"
            maxLength={15}
          />
          </div>
          <div>
          <div className="edit-mobile-btn-link" onClick={getAddressByZipCode}><p className="rp-returns-row-button-text">Edit</p></div>  
          </div> 
          <div>
          {isLoading || SelfShippingLoader ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ):(
            <Dropdown
                      options={selfStoreList.map(storeAddr => ({
                        label: `${storeAddr.name} - ${storeAddr.addr}`,
                        value: storeAddr.code
                      }))}
                      disabled={null}
                      onSelected={handleSelfShippingWarehouse}
                      activeOption={null}
                      />
            
             )}
            </div>  
        </div>
    
  );
};

export default SelfShipping;
